import { Phone } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

import { formatDate } from '@/lib/date';

import { RowAction } from './row-action';

import type { PhoneNumberConfiguration } from '@/types/phone-number.type.ts';
import type { ColumnDef } from '@tanstack/react-table';

export const getColumns = (): ColumnDef<PhoneNumberConfiguration>[] => [
  {
    id: 'id',
    accessorKey: 'id',
    header: 'ID',
    cell: ({ getValue }) => (
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 mt-0.5"></div>
        <div>
          <span className="font-medium">{getValue() as string}</span>
        </div>
      </div>
    ),
  },
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
  },
  {
    id: 'provider',
    accessorKey: 'provider',
    header: 'Provider',
    cell: ({ getValue }) => (
      <Badge variant="outline" className="gap-1">
        {getValue() as string}
      </Badge>
    ),
  },
  {
    id: 'phone_number',
    accessorKey: 'phone_number',
    header: 'Phone Number',
    cell: ({ getValue }) => (
      <Badge variant="outline" className="inline-flex items-center gap-2">
        <Phone className="h-4 w-4 text-blue-700 dark:text-blue-400" />
        {getValue() as string}
      </Badge>
    ),
  },
  {
    id: 'agent',
    header: 'Assigned Agent',
    cell: ({ row }) => {
      const phoneNumber = row.original;

      return phoneNumber.agent ? (
        <Badge variant="success" className="gap-1">
          {phoneNumber.agent.agent_name}
        </Badge>
      ) : (
        <Badge variant="outline" className="gap-1">
          No agent assigned
        </Badge>
      );
    },
  },
  {
    id: 'created_at',
    accessorKey: 'created_at',
    header: 'Created at',
    cell: ({ getValue }) => formatDate(getValue() as string),
  },
  {
    id: 'actions',
    cell: ({ row }) => <RowAction phoneNumber={row.original} />,
  },
];
